import React from 'react';
import PropTypes from 'prop-types';

const CheckBroken = ({color = 'currentColor', ...props}) => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M16.5 9C16.5 13.1421 13.1421 16.5 9 16.5C4.85786 16.5 1.5 13.1421 1.5 9C1.5 4.85786 4.85786 1.5 9 1.5C10.1767 1.5 11.2901 1.77099 12.2812 2.25397M15.0938 4.3125L8.53125 10.875L6.65625 9"
      stroke={color}
      strokeWidth="1.66667"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

CheckBroken.propTypes = {
  color: PropTypes.string,
};

export default CheckBroken;
